import { render, staticRenderFns } from "./TablePartnersContainer.vue?vue&type=template&id=9e567046&"
import script from "./TablePartnersContainer.vue?vue&type=script&lang=js&"
export * from "./TablePartnersContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports